<div *transloco="let t; prefix: 'memberInvitation'" class="background md:p-10">
  <div class="mx-auto w-full bg-white p-6 text-center md:w-[35rem] md:p-10 md:drop-shadow-md">
    @if (error$ | async; as error) {
      <p [innerHtml]="t('accept.error', { error })"></p>
    } @else {
      @if (profileMemberInviteDetails$ | async; as profileMemberInviteDetails) {
        <h1 class="text-center text-2xl">
          @if (!profileMemberInviteDetails.profileDetails.isClaimed) {
            {{ t('accept.heading') }}
          } @else {
            {{ t('accept.claimedHeading') }}
          }
        </h1>
        <img
          alt=""
          class="mx-auto w-60 border-1 border-solid drop-shadow-md"
          [src]="'/promotion-banner/teams-callout/team-banner.png' | staticImageUrl"
        />
        <p
          class="mb-6 text-steel-70"
          [innerHtml]="
            t('accept.subheading', {
              invitedToProfileName: profileMemberInviteDetails.invitedToProfileName,
              invitedByName: profileMemberInviteDetails.invitedByName,
            })
          "
        ></p>
        @if ((pending$ | async) === false) {
          <button type="button" class="h-12! min-h-full w-52" (click)="acceptInvite()" mat-flat-button color="primary">
            {{ t('accept.cta') }} <rma-icon glyph="arrow_forward" />
          </button>
        } @else {
          <button type="button" class="h-12! min-h-full w-52" disabled="true" mat-flat-button color="primary">
            <mat-spinner diameter="30" />
          </button>
        }
        @if (!profileMemberInviteDetails.profileDetails.isClaimed) {
          <p class="mt-6 text-steel-70" [innerHtml]="t('accept.termsConditions')"></p>
        }
      } @else {
        <div class="rma-loader">
          <mat-spinner diameter="30" />
        </div>
      }
    }
  </div>
</div>
